import React from 'react';
import { Pagination } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import { useRecoilState } from 'recoil';
import '../App.css';
import { mainBlueColor } from '../GlobalState';

interface Props {
  page: number;
  pageCount: number;
  setCurrentPage: Function;
}

const PaginationComponent: React.FC<Props> = ({
  page,
  pageCount,
  setCurrentPage
}) => {
  const [mainColor] = useRecoilState(mainBlueColor);

  const useStyles = makeStyles(() => ({
    ul: {
      '& .MuiPaginationItem-page.Mui-selected': {
        backgroundColor: mainColor,
        color: '#FFFFFF'
      }
    }
  }));

  const classes = useStyles();

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 30 }}>
      <Pagination
        classes={{ ul: classes.ul }}
        page={page}
        count={pageCount}
        size='large'
        onChange={(_, page) => setCurrentPage(page)}
      />
    </div>
  );
};
export default PaginationComponent;
